function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportationBusStopFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10V9c0-1.103.897-2 2-2h11c1.103 0 2 .897 2 2v1H12zm0 7h15v-5H12v5zm0 6h15v-4H12v4zM25 5H14a4 4 0 00-4 4v14a2 2 0 002 2h1v2a2 2 0 004 0v-2h5v2a2 2 0 004 0v-2h1a2 2 0 002-2V9a4 4 0 00-4-4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 22a1 1 0 100-2 1 1 0 000 2zM24 22a1 1 0 100-2 1 1 0 000 2zM6 8a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 15V9h2v6H5zM9.25 17h-6.5v-2h6.5v2z",
    fill: props.color
  }));
}

export default SvgIconTransportationBusStopFilled;